import React, { useState } from "react";
import WavyDivider from "./WavyDivider";
import { Instagram, Facebook, Phone, Mail, MapPin, Check } from "lucide-react";
import { siteData } from "../mock";

const Contact = () => {
  const { contact } = siteData;
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Demande de contact — ${form.name || "Site"}`);
    const body = encodeURIComponent(
      `Nom : ${form.name}\nEmail : ${form.email}\nTéléphone : ${form.phone}\n\n${form.message}`
    );
    window.location.href = `mailto:${contact.email}?subject=${subject}&body=${body}`;
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section id="contact" className="section contact">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Contact</h2>
        <h3 className="section-subtitle">
          Pour prendre rendez-vous ou pour toute autre question, n’hésitez pas à me contacter par téléphone, mail, ou en complétant le formulaire de contact ci-dessous.
        </h3>
      </div>

      <div className="contact-inner">
        <div className="contact-card">
          <h4 className="contact-name">{contact.fullName}</h4>
          <p className="contact-role">{contact.role}</p>
          <ul className="contact-list">
            <li>
              <Phone size={16} strokeWidth={1.6} />
              <a href={contact.phoneHref}>{contact.phone}</a>
            </li>
            <li>
              <Mail size={16} strokeWidth={1.6} />
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </li>
            <li>
              <Facebook size={16} strokeWidth={1.6} />
              <a href={contact.facebookUrl} target="_blank" rel="noreferrer">Facebook</a>
            </li>
            <li>
              <Instagram size={16} strokeWidth={1.6} />
              <a href={contact.instagramUrl} target="_blank" rel="noreferrer">Instagram</a>
            </li>
            <li>
              <MapPin size={16} strokeWidth={1.6} />
              <span>{contact.address.line1}</span>
            </li>
          </ul>
          <p className="contact-address-extra muted">{contact.address.metro}</p>
          <p className="contact-siret">{contact.siret}</p>
          <p className="contact-siret">{contact.entity}</p>
          <p className="contact-mediation">{contact.mediation}</p>
        </div>

        <form
          className="contact-form"
          name="contact"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          onSubmit={onSubmit}
        >
          <input type="hidden" name="form-name" value="contact" />
          <h4 className="contact-subheading">Formulaire de contact</h4>
          <div className="form-row">
            <label>
              <span>Nom</span>
              <input name="name" type="text" value={form.name} onChange={onChange} required placeholder="Votre nom" />
            </label>
            <label>
              <span>Téléphone</span>
              <input name="phone" type="tel" value={form.phone} onChange={onChange} required placeholder="Votre numéro" />
            </label>
          </div>
          <label>
            <span>Email</span>
            <input name="email" type="email" value={form.email} onChange={onChange} required placeholder="votre@email.com" />
          </label>
          <label>
            <span>Message</span>
            <textarea name="message" rows="5" value={form.message} onChange={onChange} required placeholder="Votre message…" />
          </label>
          <button type="submit" className="btn btn-primary form-submit">
            {sent ? (<><Check size={16} /> MESSAGE PRÊT À ENVOYER</>) : "ENVOYER LE MESSAGE"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
